const identity = (kind, mode, owner) => ({ kind, mode, owner });

/**
 * Normalize the three generations of Calendar form identifiers at their
 * boundary. Canonical formName wins because it identifies the concrete form
 * instance and request owner rather than only the legacy workflow type.
 */
export const normalizeCalendarFormIdentity = (values = {}) => {
  const formName = String(values?.formName || "").trim();
  const canonical = formName.toLowerCase();
  if (canonical.startsWith("appointmentform/add")) {
    return identity("appointment", "add", "appointmentForm/add");
  }
  if (canonical.startsWith("appointmentform/edit")) {
    return identity("appointment", "edit", "appointmentForm/edit");
  }
  if (canonical.startsWith("busytimeform/add")) {
    return identity("busy-time", "add", "busytimeForm/add");
  }
  if (canonical.startsWith("busytimeform/edit")) {
    return identity("busy-time", "edit", "busytimeForm/edit");
  }
  if (canonical.startsWith("appointmentautofillform")) {
    return identity("appointment", "autofill", "appointmentautofillForm");
  }

  const legacyType = String(values?.formtype || "").trim().toLowerCase();
  const legacyMode = String(values?.form_types || "").trim().toLowerCase();
  if (legacyType === "appointmentautofillform") {
    return identity("appointment", "autofill", "appointmentautofillForm");
  }
  if (legacyType === "add_busytime") {
    return identity("busy-time", "add", "busytimeForm/add");
  }
  if (legacyType === "edit_busytime") {
    return identity("busy-time", "edit", "busytimeForm/edit");
  }
  if (legacyMode === "add_appointment" || legacyType === "add_appointment") {
    return identity("appointment", "add", "appointmentForm/add");
  }
  if (legacyMode === "edit_appointment" || legacyType === "edit_appointment") {
    return identity("appointment", "edit", "appointmentForm/edit");
  }
  if (legacyType === "appointmentform") {
    return identity("appointment", "", "appointmentForm");
  }
  return identity("appointment", "", "appointmentForm");
};
